<script setup lang="ts">
  const version = __APP_VERSION__
  const companyNameLong = import.meta.env.VITE_APP_COMPANY_NAME_LONG as string
  import logoAuth from '@/assets/images/logo-auth.png'
  import { copyrightYear } from '@/functions/copyright-year'
</script>

<template>
  <div class="relative min-h-144 h-screen">
    <div class="bg-auth"></div>
    <div class="inset-0 absolute flex-center">
      <div class="card max-w-[calc(100vw-48px)] w-sm">
        <div class="block rounded-full p-1 overflow-hidden mx-auto w-24 bg-white h-24 shadow-lg -mb-12 -translate-y-12">
          <div class="rounded-full p-1 flex-center bg-white size-full">
            <img
              :src="logoAuth"
              class="size-22 max-w-none"
              :alt="'logo ' + companyNameLong">
          </div>
        </div>

        <app-router-view />
      </div>
    </div>
    <div class="absolute text-xs text-center text-white inset-x-0 bottom-4">
      v{{ version }}. &copy;{{ copyrightYear() }} {{ companyNameLong }}
    </div>
  </div>
</template>

<style scoped>
  .bg-auth {
    background-image: url("@/assets/images/bg-auth.png");
    background-size: cover;
    background-position: right center;
    position: fixed;
    inset: 0;
  }
</style>
